/*
 *
 * Generate unique IDs
 * Example use:
 * generateUniqueId('iris_componentName')
 * would return: iris_componentName_p4i141r5r7e
*/
export function generateUniqueId(prefix: string) {
    return `${prefix}_${Math.random().toString(36).substr(2)}`;
}